import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/jb-market-display/jb-market-display.css.ts
var jb_market_display_css_default = i`span{font-family:var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);font-style:normal;font-weight:var(--theme-font-light-weight, 300)}span{font-size:var(--theme-typo-p-mini-desktop-fontsize, 0.813rem);line-height:var(--theme-typo-p-mini-desktop-lineheight, 1.25rem)}div{align-items:center;display:flex}span{color:rgb(var(--theme-color-royal-blue)/var(--theme-opacity-40));line-height:unset}.long{display:none}@media(min-width: 600px){.short{display:none}.long{display:inline-block}}`;

export {
  jb_market_display_css_default
};
